/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateRecurringTaskRequest
 */
export interface UpdateRecurringTaskRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateRecurringTaskRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRecurringTaskRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateRecurringTaskRequest
     */
    dimensionId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRecurringTaskRequest
     */
    evidenceRequired?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateRecurringTaskRequest
     */
    slaHours?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateRecurringTaskRequest
     */
    notes?: string;
}

/**
 * Check if a given object implements the UpdateRecurringTaskRequest interface.
 */
export function instanceOfUpdateRecurringTaskRequest(value: object): value is UpdateRecurringTaskRequest {
    return true;
}

export function UpdateRecurringTaskRequestFromJSON(json: any): UpdateRecurringTaskRequest {
    return UpdateRecurringTaskRequestFromJSONTyped(json, false);
}

export function UpdateRecurringTaskRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateRecurringTaskRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'dimensionId': json['dimensionId'] == null ? undefined : json['dimensionId'],
        'evidenceRequired': json['evidenceRequired'] == null ? undefined : json['evidenceRequired'],
        'slaHours': json['slaHours'] == null ? undefined : json['slaHours'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function UpdateRecurringTaskRequestToJSON(json: any): UpdateRecurringTaskRequest {
    return UpdateRecurringTaskRequestToJSONTyped(json, false);
}

export function UpdateRecurringTaskRequestToJSONTyped(value?: UpdateRecurringTaskRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
        'dimensionId': value['dimensionId'],
        'evidenceRequired': value['evidenceRequired'],
        'slaHours': value['slaHours'],
        'notes': value['notes'],
    };
}

